import { GET, PATCH, POST } from '../common/common.service'
import endpointsPricesFuelStations, {
  endpointsAlvicPrices,
  endpointsMineturPrices,
  endpointsSummaryFuelStations,
} from './endpoints'

export const PricesFuelStationsService = {
  getPrices: async ({ filter, sort, limit, skip }) =>
    GET(endpointsPricesFuelStations.LOAD(filter, sort, limit, skip)),
  changePrice: async (body) =>
    PATCH(endpointsPricesFuelStations.CHANGEPRICE, body),
  addPrice: async (body) => POST(endpointsPricesFuelStations.CHANGEPRICE, body),
  getCenterPrice: async (id) =>
    GET(endpointsPricesFuelStations.CENTER_PRICES(id)),
}

const MineturPricesService = {
  getPrices: async ({ filter, sort, limit, skip }) =>
    GET(endpointsMineturPrices.LOAD(filter, sort, limit, skip)),
  changePrice: async (body) => PATCH(endpointsMineturPrices.CHANGEPRICE, body),
  addPrice: async (body) => POST(endpointsMineturPrices.CHANGEPRICE, body),
  getCenterPrice: async ({ id, filter, sort, limit, skip }) =>
    GET(endpointsMineturPrices.OWN_STATION(id, filter, sort, limit, skip)),
  getLastPriceCenter: async (id) =>
    GET(endpointsMineturPrices.OWN_STATIONS_LAST_PRICE(id)),
}

const AlvicPricesService = {
  getPrices: async ({ filter, sort, limit, skip }) =>
    GET(endpointsAlvicPrices.LOAD(filter, sort, limit, skip)),
}

const SummaryFuelStationsService = {
  getSummary: async ({ filter, sort, limit, skip }) =>
    GET(endpointsSummaryFuelStations.LOAD(filter, sort, limit, skip)),
}

export { MineturPricesService, AlvicPricesService, SummaryFuelStationsService }
